import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { getDashboardRoute } from "@/utils/onboardingUtils";
import trailingIcon from "@/assets/UserPageIcons/TrailingIcon.svg";
import "./Breadcrumb.css";

const Breadcrumb = ({ items, className = "", backButtonPath = null, onBackClick = null, onNavigate = null, hideBackButton = false, rightContent = null, hideItems = false, title = null }) => {
  const navigate = useNavigate();

  if (!items || items.length === 0) return null;

  const handleNavigation = (path) => {
    const targetPath = path === "/financial-dashboard" ? getDashboardRoute() : path;
    if (onNavigate) {
      onNavigate(targetPath);
    } else {
      navigate(targetPath);
    }
  };

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else if (backButtonPath) {
      handleNavigation(backButtonPath);
    } else {
      if (onNavigate) {
        onNavigate(null);
      } else {
        navigate(-1);
      }
    }
  };

  return (
    <div className={`breadcrumb-desktop ${className}`}>
      {!hideItems && (
        <div className="breadcrumb-left">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            const isCurrent = item.isCurrent || isLast;

            return (
              <div key={index} style={{ display: "flex", alignItems: "center" }}>
                {isCurrent ? (
                  <span className="breadcrumb-item breadcrumb-item--active">{item.label}</span>
                ) : item.path ? (
                  <span
                    className="breadcrumb-item breadcrumb-item-link"
                    onClick={() => handleNavigation(item.path)}
                  >
                    {item.label}
                  </span>
                ) : (
                  <span className="breadcrumb-item">{item.label}</span>
                )}
                {!isLast && (
                  <img src={trailingIcon} alt="" className="breadcrumb-arrow" />
                )}
              </div>
            );
          })}
        </div>
      )}

      {hideItems && title && (
        <div className="breadcrumb-left">
          <h1 className="breadcrumb-page-title">{title}</h1>
        </div>
      )}

      {rightContent && (
        <div className="breadcrumb-right-content">
          {rightContent}
        </div>
      )}

      {!hideBackButton && !rightContent && (
        <button className="breadcrumb-back-btn" onClick={handleBackClick}>
          ← Back
        </button>
      )}

    </div>
  );
};

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string,
      isCurrent: PropTypes.bool,
    })
  ).isRequired,
  className: PropTypes.string,
  showBackButton: PropTypes.bool,
  backButtonPath: PropTypes.string,
  onBackClick: PropTypes.func,
  onNavigate: PropTypes.func,
  hideBackButton: PropTypes.bool,
  rightContent: PropTypes.node,
  hideItems: PropTypes.bool,
  title: PropTypes.string,
};

export default Breadcrumb;
